module.exports = __webpack_public_path__ + "img/375.bfde9a81.jpg";